export default __webpack_public_path__ + "beta-maps-guides-streets-960-da3d9460b56e1987a0160277dc8094d5.png";